var _use, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBallonIcon = function SvgBallonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24
  }, props), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ballon-icon_svg__a",
    fill: "#D60F14"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ballon-icon_svg__a",
    fillRule: "evenodd",
    d: "M24 12c0-6.64-5.36-12-12-12S0 5.36 0 12s5.36 12 12 12 12-5.36 12-12m-7.082-2.311A4.932 4.932 0 0 0 12 4.77v-.05A4.932 4.932 0 0 0 7.082 9.64c0 .541.098 1.082.246 1.574.455 1.366 1.684 3.555 2.727 5.413.421.751.812 1.447 1.109 2.013 0 .025.012.037.024.05.013.012.025.024.025.049a.931.931 0 0 0 .787.442c.393 0 .688-.196.836-.491.225-.451.624-1.176 1.085-2.015 1.15-2.09 2.688-4.886 2.899-5.903a8.04 8.04 0 0 0 .098-1.082M12 7.328c1.23 0 2.213.983 2.213 2.213S13.23 11.754 12 11.754a2.204 2.204 0 0 1-2.213-2.213c0-1.23.983-2.213 2.213-2.213M22.623 12c0-5.852-4.77-10.623-10.623-10.623C6.148 1.377 1.377 6.147 1.377 12c0 5.852 4.77 10.623 10.623 10.623 5.852 0 10.623-4.77 10.623-10.623"
  }))));
};
export default SvgBallonIcon;